import { Badge } from "@/components/ui/badge";

const WhyNow = () => {
  return (
    <section id="why" className="py-16">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-foreground mb-12">Why Now</h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center space-y-4">
            <Badge variant="secondary" className="mb-2">Macro</Badge>
            <div className="text-3xl mb-4">📉</div>
            <h3 className="text-xl font-semibold text-foreground">Affordability crisis</h3>
            <p className="text-muted-foreground">
              Down payments have become the gating factor for otherwise qualified buyers.
            </p>
          </div>
          
          <div className="text-center space-y-4">
            <Badge variant="secondary" className="mb-2">Technology</Badge>
            <div className="text-3xl mb-4">💻</div>
            <h3 className="text-xl font-semibold text-foreground">Fintech maturity</h3>
            <p className="text-muted-foreground">
              Modern rails enable responsible, transparent experiences for new financial products.
            </p>
          </div>
          
          <div className="text-center space-y-4">
            <Badge variant="secondary" className="mb-2">Design</Badge>
            <div className="text-3xl mb-4">🔗</div>
            <h3 className="text-xl font-semibold text-foreground">Platform-first</h3>
            <p className="text-muted-foreground">
              Built to collaborate with the ecosystem — not compete with it.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyNow;